import {
    IconLetterT, IconVariable, IconPhoto, IconSquare, IconTextOrientation,
    IconQrcode, IconBarcode, IconTable,
} from '@tabler/icons-react';
import { ELEMENT_TYPES } from '../schema/documentSchema';
import { isTextOnPath } from '../utils/textPathLayout';
import { shapeGlyphIcon } from './shapeGlyph';

export const TYPE_ICONS = {
    [ELEMENT_TYPES.TEXT]: IconLetterT,
    [ELEMENT_TYPES.PLACEHOLDER]: IconVariable,
    [ELEMENT_TYPES.IMAGE]: IconPhoto,
    [ELEMENT_TYPES.QRCODE]: IconQrcode,
    [ELEMENT_TYPES.BARCODE]: IconBarcode,
    [ELEMENT_TYPES.TABLE]: IconTable,
};

/** Figma-style layer icon for an element (shapes draw their own outline). */
export function elementIcon(el) {
    if (!el) return IconSquare;
    if (el.type === ELEMENT_TYPES.SHAPE) return shapeGlyphIcon(el.shape);
    if (isTextOnPath(el)) return IconTextOrientation;
    return TYPE_ICONS[el.type] || IconSquare;
}
